import TeamMultiSelectContainer from '../team-multi-select-container/TeamMultiSelectContainer';
import React, { Component } from 'react';
import * as _ from 'lodash';
import './DelegateAlertModalContent.scss';
import TransparentButton from '../button/transparent-button/TransparentButton';
import { BlueContainedButton } from '../button/blue-contained-button/BlueContainedButton';

export class DelegateAlertModalContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            teamIds: []
        };
    }

    getTeamIds = teams => _.map(teams, team => team.id);

    handleTeamSelectChange = teams =>
        this.setState({
            ...this.state,
            teamIds: this.getTeamIds(teams)
        });

    render = () => (
        <div className={'delegate-alert-modal-content'}>
            <div>
                <TeamMultiSelectContainer
                    onChange={this.handleTeamSelectChange}
                />
            </div>

            <div className={'row modal-actions'}>
                <TransparentButton onClick={this.props.closeModal}>
                    Cancel
                </TransparentButton>

                <BlueContainedButton
                    text={'Delegate Alert'}
                    onClick={() =>
                        this.props.delegateAlert(
                            this.props.alert,
                            this.state.teamIds
                        )
                    }
                />
            </div>
        </div>
    );
}
